import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function ClienteDetalheCabecalho({ entidade, onOpenContactos }) {
  if (!entidade) return null;

  const refCliente = String(entidade.ref || entidade.refentidade || "").trim();

  const nomeCliente = String(entidade.nome || "").trim();
  const nif = String(entidade.nif || "").trim();
  const vendedor = String(entidade.vendedor || "").trim();

  return (
    <MDBox display="flex" alignItems="flex-start" justifyContent="space-between" gap={2} p={2}>
      <MDBox minWidth={0}>
        <MDTypography
          variant="h5"
          fontWeight="medium"
          sx={{
            overflowWrap: "anywhere",
          }}
        >
          {nomeCliente || "Cliente"}
        </MDTypography>

        <MDBox mt={0.75} display="flex" alignItems="center" flexWrap="wrap" gap={1.5}>
          {refCliente ? (
            <MDTypography variant="body2" color="text">
              <strong>Referência:</strong> {refCliente}
            </MDTypography>
          ) : null}

          {nif ? (
            <MDTypography variant="body2" color="text">
              <strong>NIF:</strong> {nif}
            </MDTypography>
          ) : null}

          {vendedor ? (
            <MDTypography variant="body2" color="text">
              <strong>Vendedor:</strong> {vendedor}
            </MDTypography>
          ) : null}
        </MDBox>
      </MDBox>

      <Tooltip title="Gerir contactos">
        <span>
          <IconButton
            color="info"
            onClick={onOpenContactos}
            disabled={!refCliente || typeof onOpenContactos !== "function"}
          >
            <Icon>calendar_month</Icon>
          </IconButton>
        </span>
      </Tooltip>
    </MDBox>
  );
}
